import { render, staticRenderFns } from "./ListApproveOrder.vue?vue&type=template&id=56ec0906&scoped=true&"
import script from "./ListApproveOrder.vue?vue&type=script&lang=js&"
export * from "./ListApproveOrder.vue?vue&type=script&lang=js&"
import style0 from "./ListApproveOrder.vue?vue&type=style&index=0&id=56ec0906&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ec0906",
  null
  
)

export default component.exports